import { Route } from 'react-router-dom';
import { Main } from './views/Main';
import { Review } from './views/Review';
import { ReadyBy } from './views/ReadyBy';
import { Pharmacy } from './views/Pharmacy';
import { Status } from './views/Status';
import { Canceled } from './views/Canceled';
import { NoMatch } from './views/NoMatch';
import { InfoPage } from './views/Info';
import { PatientAnalyticsProvider } from './hooks/usePatientAnalytics';

export const routeElements = (
  <Route>
    <Route
      path="/"
      element={
        <PatientAnalyticsProvider>
          <Main />
        </PatientAnalyticsProvider>
      }
    >
      <Route path="/review" element={<Review />} />
      <Route path="/readyBy" element={<ReadyBy />} />
      <Route path="/pharmacy" element={<Pharmacy />} />
      <Route path="/status" element={<Status />} />
      <Route path="/canceled" element={<Canceled />} />
    </Route>
    <Route
      path="/info"
      element={
        <PatientAnalyticsProvider>
          <InfoPage />
        </PatientAnalyticsProvider>
      }
    />
    <Route
      path="*"
      element={
        <PatientAnalyticsProvider>
          <NoMatch />
        </PatientAnalyticsProvider>
      }
    />
  </Route>
);
